import { Location } from '@app/shared/routes';

const LogoutLocation = new Location({ path: '/logout' });

export { LogoutLocation };
